import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { Router } from "@angular/router";
import {
  DxAutocompleteComponent,
  DxAutocompleteModule,
} from "devextreme-angular";
import { LoadOptions } from "devextreme/data";
import CustomStore from "devextreme/data/custom_store";
import DataSource from "devextreme/data/data_source";
import { EnterKeyEvent } from "devextreme/ui/autocomplete";
import { lastValueFrom } from "rxjs";
import {
  GlobalSearchCategory,
  GlobalSearchRecord,
  GlobalSearchResponse,
  GroupedRecord,
} from "../../../domain/models/global-search.model";
import { SignalService } from "../../services/loader.service";
import { showNotification } from "../../utils/toast";
import { ResultsModalComponent } from "../results-modal/results-modal.component";
import { GlobalSearchService } from "./global-search.service";

@Component({
  selector: "smart-global-search",
  standalone: true,
  imports: [CommonModule, DxAutocompleteModule, ResultsModalComponent],
  templateUrl: "./global-search.component.html",
  styleUrl: "./global-search.component.scss",
})
export class GlobalSearchComponent {
  searchQuery: string = "";
  datasource = new DataSource({
    store: new CustomStore({
      key: "id",
      load: (loadOptions: LoadOptions) => {
        this.searchQuery = loadOptions.searchValue;
        return lastValueFrom(
          this.globalService.retrieveGlobalData(this.searchQuery),
        )
          .then((response: GlobalSearchResponse) => {
            if (response.search.length === 0) {
              showNotification("No results found for this search", "warning");
            }
            const groupedData = this.mapSearchToGroupData(response);
            return {
              data: groupedData,
            };
          })
          .catch(() => {
            if (loadOptions.searchValue.length < 3) {
              showNotification(
                "Search query must be at least 3 characters long",
                "warning",
              );
            } else {
              showNotification("Error while loading data", "error");
            }
            throw new Error("Data loading error");
          });
      },
    }),
  });
  results: GlobalSearchRecord[] = [];
  searchType: string = "";
  isPopupVisible: boolean = false;

  constructor(
    private globalService: GlobalSearchService,
    private router: Router,
    private loaderService: SignalService,
  ) {}

  redirectToSelectedItem(
    item: GlobalSearchRecord,
    element: DxAutocompleteComponent,
  ) {
    this.loaderService.loadingSignal.set(true);

    if (item.type === "Resource") {
      this.router.navigateByUrl(`/personnel/${item.id}`).then((x) => {
        element.instance.reset();
        element.instance.blur();
      });
    } else {
      const itemType = item.type.toLowerCase();
      const agreementId = item.id;

      this.router.navigateByUrl(`/${itemType}/${agreementId}`).then((x) => {
        element.instance.reset();
        element.instance.blur();
      });
    }
  }

  mapSearchToGroupData(response: GlobalSearchResponse): GroupedRecord[] {
    return response.search.map((category: GlobalSearchCategory) => ({
      key: category.type,
      items: category.count > 0 ? category.records : null,
      count: category.count,
    }));
  }

  showAllResultOfType(type: string, element: DxAutocompleteComponent) {
    this.globalService
      .retrieveAllDocumentsOfType(type, this.searchQuery)
      .subscribe((records) => {
        this.results = records;
        this.searchType = type;
        this.isPopupVisible = true;
        element.instance.reset();
        element.instance.blur();
      });
  }

  hideModal() {
    this.isPopupVisible = false;
  }

  onKeyDown(e: EnterKeyEvent, giacomo: DxAutocompleteComponent) {
    giacomo.instance
      .getDataSource()
      .reload()
      .then((res) => giacomo.instance.open());
  }
}
